import { observable, action, computed } from 'mobx';
import { STATUS } from '../constants/status';
import moment from 'moment';
import _ from 'lodash';
import FormStore from "./FormStore";
import {
  PENDING, ASSIGNED, PICKUP_SUCCEEDED, DROPOFF_READY, DROPOFF_SUCCEEDED, GEOCODED, DAMAGED,
  DROPOFF_FAILED, PICKUP_FAILED, RETURN_SUCCEEDED, PICKUP_EN_ROUTE, PICKUP_READY, DROPOFF_EN_ROUTE,
  CANCELLED_AFTER_PICKUP, CANCELLED_BEFORE_PICKUP,
  GEOCODE_FAILED, GEOCODE_FAILED_DROPOFF, GEOCODE_FAILED_PICKUP,
  RECEIVED_DAMAGED, MISSING, UNDELIVERABLE, UNSERVICEABLE, DISPOSABLE, RESCHEDULED, RETURNED_TO_CLIENT_PENDING, RETURNED_TO_CLIENT_SUCCEEDED
} from '../constants/shipmentStatus';

import {searchInObject} from "../utils/search";
import {toast} from "react-toastify";

class DeliveryStore {
    constructor(api, dataorchAPI) {
        this.api = api;
        this.dataorchAPI = dataorchAPI;
        this.showStastistic = true;
        this.shipmentDropoffForm = new FormStore(this);
        this.shipmentPickupForm = new FormStore(this);
        this.shipmentCustomerForm = new FormStore(this);
        this.shipmentValueInfoForm = new FormStore(this);
        let today = moment().startOf('day');
        this.start = today.unix();
        // this.start = moment('2018-12-10').unix() * 1000
        this.regions = [];
        this.stores = [];
        this.profiles = [];
        this.service_levels = [];
        this.allRegions = ['SFO', 'LAX', 'LAXSD', 'PHX', 'PNS']

        // this.activeLocationHandlder = setInterval(() => {
        //   this.activeDriverLocations = this.processActiveDrivers(this.assignments, this.lastKnownLocations, 600000)
        // }, 15000)
    }

    @observable start;
    @observable shipments = [];
    @observable loadingShipments = false;
    @observable selectedShipment = null;
    @observable sortBy = '-id';
    @observable inlineFilter = null;
    @observable showStatistic = false;
    @observable boundary = null;

    @observable unrouted = [];
    @observable pending = [];
    @observable inprogress = [];
    @observable succeeded = [];
    @observable failed = [];
    @observable returnedPending = [];
    @observable returnedSuccess = [];
    @observable exception = [];
    @observable error = [];
    @observable stats;
    @observable inlineStats;
    @observable warehouses = [];
    @observable enableStoreFilter = false;
    @observable showActualDropoffMarker = false;
    @observable clientSettings = {};
    @observable regionList = [];
    statusFilter = null;
    updateCache = {};

    shipmentsRequested = 0;

    handleShipmentModifier(msg) {
        const comps = msg.split(':')
        if (comps.length < 3) return
        if (comps[1] === 'CREATED') {
          this.processNewShipment(comps)
          return;
        }
        if (comps[1] !== 'STATUS_UPDATED') return
        const shipmentId = parseInt(comps[0])
        const status = comps[2]

        // check for current data
        let shipment = this.shipments.filter(s => s.shipment.id === shipmentId)
        if (shipment.length < 1) return

        console.log('got update')
        this.updateCache[shipmentId] = {fulfilled_ts: new Date().toISOString(), status: status}

        /*
        let shipments = this.shipments.map(s => s.shipment.id === shipmentId ? Object.assign({}, s, {fulfilled_ts: new Date().toISOString(), shipment: Object.assign(s.shipment, {status})})  : s)
        this.refreshShipmentList()
        */
        this.applyChange()
    }

    @action
    applyChange_() {
      if (_.isNil(this.updateCache) || _.isEmpty(this.updateCache)) return
      console.log('apply update')
      let shipments = this.shipments.map(s => {
        if (this.updateCache[s.shipment.id]) {
          const { fulfilled_ts, status, dropoff_earliest_ts, dropoff_latest_ts} = this.updateCache[s.shipment.id]
          return Object.assign({}, s, {fulfilled_ts: new Date().toISOString(), shipment: Object.assign(s.shipment, 
            {status, dropoff_earliest_ts, dropoff_latest_ts})})
        } else {
          return s
        }
      })
      console.log('copy status done')
      this.shipments = shipments
      this.updateCache = {}
      this.refreshShipmentList()
      console.log('done update')
    }
    applyChange = _.debounce(this.applyChange_, 10000, { 'maxWait': 30000 })

    // React to focus / blur action
    @action
    onFocus() {
      this.applyChange = _.debounce(this.applyChange_, 10000, { 'maxWait': 30000 })
      this.applyChange()
    }

    @action
    onBlur() {
      this.applyChange = _.debounce(this.applyChange_, 30000, { 'maxWait': 60000 })
    }

    processNewShipment(comps) {
      const shipmentId = parseInt(comps[0])
      const clientId = parseInt(comps[2])
    }

    @computed
    get searchFilter() {
        return {
            order: this.sortBy,
            regions: this.regions,
            start_date: this.start,
            clients: this.clients ? this.clients.join(',') : '',
            end_date: this.start + 24 * 3600,
            stores: this.stores,
            profiles: this.profiles,
            service_levels: this.service_levels,
            requested: this.shipmentsRequested
        }
    }

    @action
    setDate(d) {
        if (d) {
            this.start = moment(d).unix()
        } else {
            this.start = null
        }
        this.loadShipments()
    }

    @action
    setRegions(r) {
        this.regions = r;
        this.selectedShipment = null;
        this.loadShipments();
    }

    @action
    setStores(s) {
      this.stores = s;
      this.selectedShipment = null;
      this.loadShipments();
    }

    @action
    setProfiles(s) {
      this.profiles = s;
      this.selectedShipment = null;
      this.loadShipments();
    }

    @action
    setSerivceLevels(s) {
      this.service_levels = s;
      this.selectedShipment = null;
      this.loadShipments();
    }

    @action
    setSortBy(sort) {
      this.sortBy = sort;
      this.selectedShipment = null;
      this.loadShipments();
    }

    @action
    toggleStatistic() {
        this.showStatistic = !this.showStatistic
    }

    @action
    setSelectedShipment(shipment) {
      this.selectedShipment = shipment;
      if (!shipment) {
        if (this.global_boundary) {
          this.boundary = this.global_boundary
        }
        return
      }
      // recalculate the boundary
      const { dropoff_address } = shipment
      let boundary = dropoff_address?.longitude ? [
        [dropoff_address?.longitude - 0.02, dropoff_address?.latitude - 0.02],
        [dropoff_address?.longitude + 0.02, dropoff_address?.latitude + 0.02]
      ] : [
        [dropoff_address?.lng - 0.02, dropoff_address?.lat - 0.02],
        [dropoff_address?.lng + 0.02, dropoff_address?.lat + 0.02]
      ]
      this.boundary = boundary

      // Shipment Dropoff
      this.shipmentDropoffForm.data = {
        dropoff_note: shipment.dropoff_note,
        dropoff_access_code: shipment.dropoff_access_code,
        dropoff_additional_instruction: shipment.dropoff_additional_instruction
      };

      // Shipment Pickup
      this.shipmentPickupForm.data = {
        pickup_note: shipment.pickup_note
      };


      // Shipment Customer
      this.shipmentCustomerForm.data = shipment.customer;

      this.shipmentValueInfoForm.data = {
        value: shipment.value,
        currency: shipment.currency
      };
    }

    @action
    downloadCsv(url, callback) {
      this.loadingCsv = true;
      this.shipmentsRequested = Date.now()
      this.api.get(url, this.searchFilter)
        .then(response => {
          this.loadingCsv = false;
          if (callback) callback(response.data);
        }).catch((e) => {
        this.loadingCsv = false; // TODO: display error
      })
    }

    // list shipments
    @action
    loadShipments() {
        this.loadingShipments = true;
        this.shipmentsRequested = Date.now()
        this.api.get('/shipments/brands/by-date', this.searchFilter)
            .then(response => {
                if (response.config.params.requested !== this.shipmentsRequested)
                    return
                this.shipments = response.data ? response.data : [];
                this.processShipments(this.shipments); // TODO: manipulate date into proper format
                this.loadingShipments = false;
            }).catch((e) => {
                this.loadingShipments = false; // TODO: display error
            })
    }

    @action
    loadWarehouses() {
      this.api.get('/shipments/warehouses').then(response => {
        if (response.ok) {
          if (response.data && response.data.length) {
            this.warehouses = response.data.map(wh => ({
              label: `${wh.alias} - ${wh.owner_facility_id || wh.id}`,
              value: wh.id,
            }));
          }
        }
      })
    }

    @action
    loadRegions() {
      this.dataorchAPI.get('/regions').then((response) => {
        if (response.ok) this.regionList = response.data.map(({ properties }) => ({ label: `[${properties.code}] ${properties.display_name}`, value: properties.code }));
      });
    }

    @action
    getSettings(callback) {
      this.api.get('/shipments/client-settings').then(response => {
        if (response.ok) {
          this.clientSettings = response.data;
          if (callback) callback(response);
        }
      })
    }

    @action
    setStoreFilterable(value) {
      this.enableStoreFilter = value;
    }

    @action
    setShowActualDropoffMarker(value) {
      this.showActualDropoffMarker = value;
    }

    @observable labelingShipments = false;
    @action
    requestLabelShipments(order, callback) {
        this.labelingShipments = true;
        this.shipmentsRequested = Date.now()
        const filter = Object.assign(this.searchFilter, {order});
        this.api.get('/shipments/by-date/label', filter)
            .then(response => {
              console.log('response is: ', response);
              if (callback) callback(response.data)
            }).catch((e) => {
                this.labelingShipments = false; // TODO: display error
            })
    }

    @action
    pingRequestLabelShipments(request, callback) {
        this.api.get(`/shipments/by-date/label/${request.id}`)
            .then(response => {
              if (callback) callback(response.data);
            })
    }

    @action
    setInlineFilter(q) {
        this.inlineFilter = q;
        this.filterShipments()
    }

    filterShipments = _.debounce(this.refreshShipmentList, 250, { 'maxWait': 1000 })

    @action
    refreshShipmentList() {
      let unrouted = this.shipments
        .filter(s => _.isNil(s.shipment.assignment_id))
        .filter(
          s =>
            ![
              CANCELLED_AFTER_PICKUP,
              CANCELLED_BEFORE_PICKUP,
              UNSERVICEABLE,
              UNDELIVERABLE,
              DISPOSABLE,
              GEOCODE_FAILED,
              GEOCODE_FAILED_DROPOFF,
              GEOCODE_FAILED_PICKUP,
              RESCHEDULED,
            ].includes(s.shipment.status) &&
            ![MISSING, RECEIVED_DAMAGED].includes(s.shipment.inbound_status)
        );

      let pending = this.shipments.filter(
        s =>
          s.shipment.assignment_id &&
          (_.isNil(s.shipment.status) ||
            [PENDING, ASSIGNED, GEOCODED].includes(s.shipment.status) ||
            (RESCHEDULED === s.shipment.status && s.shipment.assignment_id !== undefined))
      );

      let inprogress = this.shipments.filter(s =>
        [PICKUP_SUCCEEDED, DROPOFF_READY, PICKUP_READY, PICKUP_EN_ROUTE, DROPOFF_EN_ROUTE].includes(s.shipment.status)
      );

      let succeeded = this.shipments.filter(s => [DROPOFF_SUCCEEDED].includes(s.shipment.status));

      let failed = this.shipments
        .filter(s => [DROPOFF_FAILED, RETURN_SUCCEEDED].includes(s.shipment.status))
        .filter(s => ![MISSING, RECEIVED_DAMAGED].includes(s.shipment.inbound_status));

      let exception = this.shipments.filter(
        s =>
          [
            CANCELLED_AFTER_PICKUP,
            CANCELLED_BEFORE_PICKUP,
            UNSERVICEABLE,
            UNDELIVERABLE,
            DISPOSABLE,
            PICKUP_FAILED,
            DAMAGED,
          ].includes(s.shipment.status) || [MISSING, RECEIVED_DAMAGED].includes(s.shipment.inbound_status)
      );

      let error = this.shipments.filter(s =>
        [GEOCODE_FAILED, GEOCODE_FAILED_DROPOFF, GEOCODE_FAILED_PICKUP].includes(s.shipment.status)
      );

      let returnedPending = this.shipments.filter(s => [RETURNED_TO_CLIENT_PENDING].includes(s.shipment.status));

      let returnedSuccess = this.shipments.filter(s => [RETURNED_TO_CLIENT_SUCCEEDED].includes(s.shipment.status));
      // let exception = this.shipments.filter(s => s.shipment.status && s.shipment.status.toLowerCase().includes("cancel"));
      // console.log(_.uniqBy(data.map(s => s.shipment.status)))
      // Order By dropoff_earliest_ts
      unrouted = this.shipmentOrderBy(unrouted, ['shipment.dropoff_earliest_ts'], ['asc']);
      pending = this.shipmentOrderBy(pending, ['shipment.dropoff_earliest_ts'], ['asc']);
      inprogress = this.shipmentOrderBy(inprogress, ['shipment.dropoff_earliest_ts'], ['asc']);
      succeeded = this.shipmentOrderBy(succeeded, ['shipment.dropoff_earliest_ts'], ['asc']);
      failed = this.shipmentOrderBy(failed, ['shipment.dropoff_earliest_ts'], ['asc']);
      exception = this.shipmentOrderBy(exception, ['shipment.dropoff_earliest_ts'], ['asc']);
      error = this.shipmentOrderBy(error, ['shipment.dropoff_earliest_ts'], ['asc']);
      returnedPending = this.shipmentOrderBy(returnedPending, ['shipment.dropoff_earliest_ts'], ['asc']);
      returnedSuccess = this.shipmentOrderBy(returnedSuccess, ['shipment.dropoff_earliest_ts'], ['asc']);

      this.stats = {
        total: Math.max(this.shipments.length, 0),
        succeeded: succeeded.length,
        failed: failed.length,
        pending: pending.length,
        inprogress: inprogress.length,
        unrouted: unrouted.length,
        returnedPending: returnedPending.length,
        returnedSuccess: returnedSuccess.length,
        late: succeeded.filter(s => s.latest_dropoff_ts < s.fulfilled_ts).length,
        early: succeeded.filter(s => s.earliest_dropoff_ts > s.fulfilled_ts).length
      }

      // console.log(new Date(), '3. Inline Filter')
      if (this.inlineFilter) {
        let u = this.inlineFilter.toUpperCase().trim()
        // let filterName = (s) => s.customer && s.customer.name && s.customer.name.toUpperCase().indexOf(u) !== -1;
        let filterInternal = (s) => s.internal_id && s.internal_id.toUpperCase().indexOf(u) !== -1;
        // let filterShipment = (s) => filterName(s.shipment) || filterInternal(s.shipment)
        // let filterShipment = (s) => filterInternal(s.shipment)
        let filterShipment = (s) => {
          const searchFields = [
            "shipment.customer.name",
            "shipment.tracking_code",
            "shipment.internal_id",
            "shipment.id",
          ];

          return searchInObject(s, this.inlineFilter, "i", searchFields);
        };
        unrouted = unrouted.filter(filterShipment)
        pending = pending.filter(filterShipment)
        inprogress = inprogress.filter(filterShipment)
        succeeded = succeeded.filter(filterShipment)
        failed = failed.filter(filterShipment)
        exception = exception.filter(filterShipment)
        error = error.filter(filterShipment)
        returnedPending = returnedPending.filter(filterShipment)
        returnedSuccess = returnedSuccess.filter(filterShipment)
      }

      // console.log(new Date(), '4. Inline stats')
      this.inlineStats = {
        succeeded: succeeded.length,
        failed: failed.length,
        pending: pending.length,
        inprogress: inprogress.length,
        unrouted: unrouted.length,
        returnedPending: returnedPending.length,
        returnedSuccess: returnedSuccess.length,
        error: error.length,
        exception: exception.length,
        late: succeeded.filter(s => s.latest_dropoff_ts < s.fulfilled_ts).length,
        early: succeeded.filter(s => s.earliest_dropoff_ts > s.fulfilled_ts).length
      }

      // console.log(new Date(), '5. Status filter')
      if (this.statusFilter) {
        succeeded = succeeded
          .filter(s => {
            const currentTime = moment(s.fulfilled_ts);
            const earlyTime = moment(s.earliest_dropoff_ts);
            const lateTime = moment(s.latest_dropoff_ts);

            return (
              this.statusFilter.indexOf('ON_TIME') !== -1 && currentTime.isBetween(earlyTime, lateTime) ||
              this.statusFilter.indexOf('EARLY') !== -1 && currentTime.isBefore(earlyTime) ||
              this.statusFilter.indexOf('LATE') !== -1 && currentTime.isAfter(lateTime)
            )
          })
      }
      this.unrouted = unrouted
      this.pending = pending
      this.inprogress = inprogress
      this.succeeded = succeeded
      this.failed = failed
      this.exception = exception
      this.error = error
      this.returnedPending = returnedPending
      this.returnedSuccess = returnedSuccess
    }

    @action
    shipmentOrderBy(shipments = [], orderBy = [], sort = 'asc') {
      return _.orderBy(shipments, orderBy, sort);
    }

    processShipments(data) {
      // this.shipments = data.filter(s => s.shipment.dropoff_address.lat && s.shipment.dropoff_address.lng).filter(s => s.shipment.status !== '"GEOCODE_FAILED"')

      this.refreshShipmentList()

        // get boundary
        const lats = this.shipments.filter(s => s.shipment.dropoff_address.lat && s.shipment.dropoff_address.lng).map(s => s.shipment.dropoff_address.lat)
        const lngs = this.shipments.filter(s => s.shipment.dropoff_address.lat && s.shipment.dropoff_address.lng).map(s => s.shipment.dropoff_address.lng)

        if (lats.length < 2) {
          this.global_boundary = null
        } else {
          this.global_boundary = [
            [_.min(lngs), _.min(lats)],
            [_.max(lngs), _.max(lats)]
          ]
        }
        if (!this.selectedShipment) {
          this.boundary = this.global_boundary
        }
    }

    filterShipmentSuccess(statuses) {
      this.statusFilter = statuses
      this.refreshShipmentList()
      /*
      let shipmentSuccessed = this.shipments;

      if(!statuses || (statuses && statuses.length < 1)) {
        this.succeeded = [];
        return;
      }
      shipmentSuccessed = shipmentSuccessed
        .filter(s => [DROPOFF_SUCCEEDED].indexOf(s.shipment.status) !== -1)
        .filter(s => {
          const currentTime = moment(s.fulfilled_ts);
          const earlyTime = moment(s.shipment.dropoff_earliest_ts);
          const lateTime = moment(s.shipment.dropoff_latest_ts);

          return (
            statuses.indexOf('ON_TIME') !== -1 && currentTime.isBetween(earlyTime, lateTime) ||
            statuses.indexOf('EARLY') !== -1 && currentTime.isBefore(earlyTime) ||
            statuses.indexOf('LATE') !== -1 && currentTime.isAfter(lateTime)
          )
        })

      this.succeeded = shipmentSuccessed;
      */
    }

    updateShipmentDropoff(shipment, callback) {
        this.api.patch(`/shipments/${shipment.id}/notes`, this.shipmentDropoffForm.data).then((response) => {
            if(callback) {
                Object.assign(shipment, this.shipmentDropoffForm.data);
                this.selectedShipment = shipment;
                callback(response)
            }
        });
    }

    updateShipmentPickup(shipment, callback) {
      this.api.patch(`/shipments/${shipment.id}/notes`, this.shipmentPickupForm.data).then((response) => {
        if(callback) {
          Object.assign(shipment, this.shipmentPickupForm.data);
          this.selectedShipment = shipment;
          callback(response)
        }
      });
    }

    updateShipmentDropoffLocation(shipment, callback) {
      const DAC = this.shipmentDropoffForm.data.dropoff_access_code;
      const DAI = this.shipmentDropoffForm.data.dropoff_additional_instruction;

      // Valid
      this.shipmentDropoffForm.data.dropoff_access_code            = (DAC && DAC.trim() !== '') ? DAC : '';
      this.shipmentDropoffForm.data.dropoff_additional_instruction = (DAI && DAI.trim() !== '') ? DAI : '';
      this.api.put(`/shipments/${shipment.id}/dropoff-location-info`, this.shipmentDropoffForm.data).then((response) => {
        if (response.status === 200) {
          Object.assign(shipment, this.shipmentDropoffForm.data);
          this.selectedShipment = shipment;
          callback(response)
        }
      })
  }

  updateShipmentValue(shipment, callback) {
    this.api.patch(`/shipments/${shipment.id}/value`, this.shipmentValueInfoForm.data).then((response) => {

        if(callback) {
          if (response.status === 204){
            Object.assign(shipment, this.shipmentValueInfoForm.data);
              toast.success('Shipment value was updated successfully');
          }else{
              const errorMessage = response.data?.errors?.length > 0 ? response.data.errors[0] : '"Cannot update shipment value"';
              toast.error(errorMessage, {autoClose: false});
          }
          this.selectedShipment = shipment;
          callback(response)
        }
    });
  }  ß  

    updateShipmentCustomer(shipment, callback) {
        this.api.patch(`/shipments/${shipment.id}/customer`, this.shipmentCustomerForm.data).then((response) => {
            if(callback) {
                Object.assign(shipment, this.shipmentCustomerForm.data);
                this.selectedShipment = shipment;
                callback(response)
            }
        });
    }
}

export default DeliveryStore;
